// Actions types
export const RESET_STORE = 'resetStore';

// Mutations types
export const SET_GLOBAL_ERROR = 'setGlobalError';

// Getters types
export const GLOBAL_ERROR = 'globalError';
export const APP_IS_IDLE = 'appIsIdle';
